import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/about',
    name: 'AboutMe',
    component: () => import('@/views/AboutMe.vue'),
  },
  {
    path: '/skills',
    name: 'Skills',
    component: () => import('@/views/Skills.vue'),
  },
  {
    path: '/experiences',
    name: 'Experiences',
    component: () => import('@/views/Experiences.vue'),
  },
  {
    path: '/items',
    name: 'Items',
    component: () => import('@/views/Items.vue'),
  },
  {
    path: '/items/:id',
    name: 'ItemDetail',
    component: () => import('@/views/ItemDetail.vue'),
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/views/Blog.vue'),
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: () => import('@/views/BlogPost.vue'),
  },
  {
    path: '/commission',
    name: 'Commission',
    component: () => import('@/views/Commission.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})


export default router
